import React from "react";
import { TimerControl } from "../../types/timer.type";
import { TimerScreenData } from "../../types/screen.type";
import { HorTvbd } from "../../components/HorTvbd/HorTvbd";
import { StartingClassIn } from "../../components/StartingClassIn30Seconds/StartingClassIn30Seconds";
import { HorMovement } from "../Movement/Movement";


interface TimerProps {
  timerScreenData?: TimerScreenData;
  timerControlRef?: React.RefObject<TimerControl>;
}

export const Timer: React.FC<TimerProps> = ({ timerScreenData, timerControlRef }): React.JSX.Element => {

  let showFinish = timerScreenData?.type === "ending" ? true : false;

  if (!timerScreenData) {
    return (
      <></>
    );
  }

  {

    if (!timerScreenData.isWorkout) {
      return (
        <HorMovement movementScreenData={timerScreenData} />
      );
    } else {
      if (timerScreenData.isWorkoutStarting || timerScreenData.isWorkoutIntroduction) {
        return (
          <StartingClassIn
            message={timerScreenData.isWorkoutStarting ? 'stay.get_ready' : 'stay.introduction'}
            initialTotalTime={timerScreenData.progressCircle?.initialTotalTime}
            color={timerScreenData.progressCircle?.color}
            timerControlRef={timerControlRef}
          />
        );
      } else {
        return (
          <HorTvbd
            workoutName={timerScreenData.workoutName ?? ""}
            totalTime={timerScreenData.totalTime ?? 0}
            currentExercise={timerScreenData.currentExercise ?? 0}
            totalExercises={timerScreenData.totalExercises ?? 0}
            totalSets={timerScreenData.totalSets ?? 0}
            pod={timerScreenData.currentPod ?? 0}
            totalPods={timerScreenData.totalPods ?? 0}
            podDuration={timerScreenData.podDuration ?? timerScreenData.totalTime ?? 1}
            currentSetTime={timerScreenData.currentSetTime ?? 0}
            hydrate_active={timerScreenData.hydrate_active || 0}
            hydrate_total={timerScreenData.hydrate_total || 0}
            type={timerScreenData.type}
            showFinish={showFinish}
            finishImage={timerScreenData.workoutImage}
            timerControlRef={timerControlRef} />
        );
      }
    }
  }
};
